import { useCoreSelector } from '../../CoreStore';

import type { ToastsProps } from './slice';

export const useToastSlice = {
  getToasts: (): ToastsProps[] => {
    return useCoreSelector(({ toast }) => toast.toasts);
  },
};
